import { TestResolver } from "../../models";
import { Log } from "../log.helpers";
import { getSiblingValueTime } from "./custom-yup-validation-helpers";

export const notLowerTimeThanSiblingIfSiblingsNumValueSame: TestResolver = ({
  context,
  validationAdditional,
  value,
  errorMessage,
}) => {
  const siblingNum1Name = validationAdditional.num1 ?? "";
  const siblingNum2Name = validationAdditional.num2 ?? "";
  const siblingFieldName = validationAdditional.siblingName;

  if (
    siblingNum1Name &&
    siblingNum2Name &&
    context.parent[siblingNum1Name] !== context.parent[siblingNum2Name]
  ) {
    return true;
  }

  const siblingValueTime = getSiblingValueTime({
    siblingFieldName,
    context,
    value: value as string,
  });

  if (!value) {
    return true;
  }

  if (!siblingValueTime) {
    return false;
  }

  if (!((siblingFieldName as string) in context.parent)) {
    Log.warn(`Missed sibling field for ${context.path} bypass validation`);
    return true;
  }

  const { siblingTime, valueTime } = siblingValueTime;

  if (valueTime.isAfter(siblingTime)) {
    return true;
  }

  return context.createError({ message: errorMessage });
};
